

export class SmsDataReminderDataInput implements ISmsDataReminderDataInput {
    /** The mobile number with 13 character */
    mobileNumber!: string;

    constructor(data?: ISmsDataReminderDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mobileNumber = _data["mobileNumber"];
        }
    }

    static fromJS(data: any): SmsDataReminderDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new SmsDataReminderDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mobileNumber"] = this.mobileNumber;
        return data; 
    }
}

export interface ISmsDataReminderDataInput {
    /** The mobile number with 13 character */
    mobileNumber: string;
}

